// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "hr[data-v-4d5c929a]{margin:20px 0}.wrap-text[data-v-4d5c929a]{overflow-wrap:break-word;max-width:80vw;color:var(--input-label)}", ""]);
// Exports
module.exports = exports;
